import { navigateTo, useRoute } from '#imports'

import { useLogout } from '@backmarket/nuxt-layer-oauth/useLogout'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { ROUTES } from '~/scopes/auth/route-names'

export async function useBouyguesMagicLinkAuthentication() {
  const { user, fetchUser, isUserAuthenticated } = useUserStore()
  const { logout } = useLogout()
  const $httpFetch = useHttpFetch()

  const route = useRoute()

  const magicLinkId = route.params.magicLinkId as string
  const locale = route.params.locale as string

  const {
    loginDetails: { email, firstName, lastName },
  } = await $httpFetch(
    '/api/mobile-plan/in-store/v1/magic-links/:magicLinkId/login-details',
    { pathParams: { magicLinkId } },
  )

  await fetchUser()

  const query = {
    bm_journey: 'bouygues_store_customer',
    email,
    first_name: firstName,
    last_name: lastName,
    bm_auto_start_provider: 'email',
    next: route.fullPath,
  }

  if (!isUserAuthenticated.value) {
    return navigateTo(
      {
        name: ROUTES.AUTH.LOGIN,
        params: { locale },
        query,
      },
      { external: true },
    )
  }

  if (user.value.email !== email) {
    return logout({
      name: ROUTES.AUTH.LOGIN,
      params: { locale },
      query,
    })
  }

  return true
}
